import React, { useState, useEffect } from 'react';
import AsyncSelect from 'react-select/async';
import { searchTags } from '../../../../../store/action/order';

export default function (props) {
    const [ view, setView ] = useState(false);
    const [ tagInput, setTagInput ] = useState("");
    const [ selectedTags, setSelectedTags ] = useState([]);

    useEffect(() => {
        let selected = [];
        for(let i = 0; i < props.value.length; i ++) {
            selected.push({
                label:props.value[i],
                value:props.value[i]
            })
            continue;
        }
        setSelectedTags(selected);
    },[props.value]);

    const onChangeTags = (e) => {
        if (e) {
            const selected = e.reduce((r,i) => {
                r.push(i.value);
                return r
            },[])
            setSelectedTags(selected);
            props.onChange(selected)
            return;
        };
        setSelectedTags([]);
        props.onChange([]);
        return;
    }

    const getTagsData = async (inputValue) => {
        const result = await searchTags(inputValue);
        if (!result.success) return;
        const formattedResult = result.tags.reduce((r,i) => {
            r.push({label:i,value:i}); return r;
        },[]);
        return formattedResult
    }

    const handleInputChange = (value) => {
        const inputValue = value.replace(/\W/g, '');
        setTagInput(inputValue);
        return inputValue;
    };

    const promiseOptions = inputValue =>
        new Promise(resolve => {
            setTimeout(() => {
                resolve(getTagsData(inputValue));
            }, 1000);
    });
  

    return (
        <div className="border-bottom">
            <div className={`${view ? null : "filter-view"}`}>
                <div className="py-3 container">
                    <div 
                        className="pointer row justify-content-between px-4" 
                        onClick={props.open ? props.onClickOpen : props.onClickClose}
                    >
                        Tag order
                    </div>
                </div>
            </div>
            {
                props.open ? 
                    <div className="bg-lighter p-4">
                        <AsyncSelect
                            isMulti
                            cacheOptions
                            value={selectedTags}
                            onChange={e => onChangeTags(e)}
                            loadOptions={promiseOptions}
                            defaultOptions
                            onInputChange={handleInputChange}
                            placeholder="Masukkan tag order Anda"
                        />
                    </div>
                    : 
                    null
            }
        </div>
    )
};